/*
 * @创建文件时间: 2020-03-24 20:26:09
 * @最后修改人: lfq
 * @最后修改时间: 2020-03-24 20:31:45
 * @联系Qq:1360484677
 * @文件介绍: 路网结构改造
 */
export default [{
        path: 'rnAcceptanceApply',
        name: 'rnAcceptanceApply',
        meta: {
            title: '交工验收申请单',
            auth: true
        },
        component: () =>
            import ('@/views/conserve/roadNetworkRemould/rnAcceptanceApply')
    }, {
        path: 'rnAcceptanceCertificate',
        name: 'rnAcceptanceCertificate',
        meta: {
            title: '交工验收证书',
            auth: true
        },
        component: () =>
            import ('@/views/conserve/roadNetworkRemould/rnAcceptanceCertificate')
    }, {
        path: 'rnAnnualJobPlan',
        name: 'rnAnnualJobPlan',
        meta: {
            title: '年度作业计划表',
            auth: true
        },
        component: () =>
            import ('@/views/conserve/roadNetworkRemould/rnAnnualJobPlan')
    }, {
        path: 'rnCaCertificate',
        name: 'rnCaCertificate',
        meta: {
            title: '竣工验收鉴定书',
            auth: true
        },
        component: () =>
            import ('@/views/conserve/roadNetworkRemould/rnCaCertificate')
    }, {
        path: 'rnCmce',
        name: 'rnCmce',
        meta: {
            title: '施工管理综合评价表',
            auth: true
        },
        component: () =>
            import ('@/views/conserve/roadNetworkRemould/rnCmce')
    }, {
        path: 'rnComplatedCe',
        name: 'rnComplatedCe',
        meta: {
            title: '竣工验收项目综合评定表',
            auth: true
        },
        component: () =>
            import ('@/views/conserve/roadNetworkRemould/rnComplatedCe')
    }, {
        path: 'rnCompletedQe',
        name: 'rnCompletedQe',
        meta: {
            title: '竣工验收工程质量评价表',
            auth: true
        },
        component: () =>
            import ('@/views/conserve/roadNetworkRemould/rnCompletedQe')
    }, {
        path: 'rnCompletedQg',
        name: 'rnCompletedQg',
        meta: {
            title: '竣工验收委员会工程质量评分表',
            auth: true
        },
        component: () =>
            import ('@/views/conserve/roadNetworkRemould/rnCompletedQg')
    }, {
        path: 'rnDeliveryAcceptanceReport',
        name: 'rnDeliveryAcceptanceReport',
        meta: {
            title: '交工验收报告',
            auth: true
        },
        component: () =>
            import ('@/views/conserve/roadNetworkRemould/rnDeliveryAcceptanceReport')
    }, {
        path: 'rnDesignWorkCe',
        name: 'rnDesignWorkCe',
        meta: {
            title: '设计工作综合评价表',
            auth: true
        },
        component: () =>
            import ('@/views/conserve/roadNetworkRemould/rnDesignWorkCe')
    }, {
        path: 'rnImEvaluate',
        name: 'rnImEvaluate',
        meta: {
            title: '管理综合评价表',
            auth: true
        },
        component: () =>
            import ('@/views/conserve/roadNetworkRemould/rnImEvaluate')
    }, {
        path: 'rnQualityScore',
        name: 'rnQualityScore',
        meta: {
            title: '交工验收工程质量评分表',
            auth: true
        },
        component: () =>
            import ('@/views/conserve/roadNetworkRemould/rnQualityScore')
    }, {
        path: 'rnSuperviseCe',
        name: 'rnSuperviseCe',
        meta: {
            title: '监理工作综合评价表',
            auth: true
        },
        component: () =>
            import ('@/views/conserve/roadNetworkRemould/rnSuperviseCe')
    },


    {
        path: 'lwjgReportMaintainPlan',
        name: 'lwjgReportMaintainPlan',
        meta: {
            title: '维修计划上报',
            auth: true
        },
        component: () =>
            import ('@/views/maintenanceData/roadNetworkRemould/wxzxReportMaintainPlan')
    }, {
        path: 'lwjgMaintainProDesign',
        name: 'lwjgMaintainProDesign',
        meta: {
            title: '维修工程设计',
            auth: true
        },
        component: () =>
            import ('@/views/maintenanceData/roadNetworkRemould/wxzxMaintainProDesign')
    },
    {
        path: 'lwjgDesignChangeTable',
        name: 'lwjgDesignChangeTable',
        meta: {
            title: '维修设计变更',
            auth: true
        },
        component: () =>
            import ('@/views/maintenanceData/roadNetworkRemould/wxzxDesignChangeTable')
    },
    {
        path: 'lwjgMonthPay',
        name: 'lwjgMonthPay',
        meta: {
            title: '维修工作计量月报',
            auth: true
        },
        component: () =>
            import ('@/views/maintenanceData/roadNetworkRemould/wxzxMonthPay')
    },
    {
        path: 'lwjgQualityJobUnitTable',
        name: 'lwjgQualityJobUnitTable',
        meta: {
            title: '质量责任卡承包单位',
            auth: true
        },
        component: () =>
            import ('@/views/maintenanceData/roadNetworkRemould/wxzxQualityJobUnitTable')
    },
    {
        path: 'lwjgListingPaymentTable',
        name: 'lwjgListingPaymentTable',
        meta: {
            title: '清单期中支付',
            auth: true
        },
        component: () =>
            import ('@/views/maintenanceData/roadNetworkRemould/wxzxListingPaymentTable')
    },
    {
        path: 'lwjgProQsAfterEvaluateTable',
        name: 'lwjgProQsAfterEvaluateTable',
        meta: {
            title: '工程质量后评价',
            auth: true
        },
        component: () =>
            import ('@/views/maintenanceData/roadNetworkRemould/wxzxProQsAfterEvaluateTable')
    },
    {
        path: 'lwjgAcceptApplyTable',
        name: 'lwjgAcceptApplyTable',
        meta: {
            title: '交工验收申请',
            auth: true
        },
        component: () =>
            import ('@/views/maintenanceData/roadNetworkRemould/wxzxAcceptApplyTable')
    },
    {
        path: 'lwjgAcceptApply',
        name: 'lwjgAcceptApply',
        meta: {
            title: '交工验收申请',
            auth: true
        },
        component: () =>
            import ('@/views/maintenanceData/roadNetworkRemould/wxzxAcceptApply')
    },
    {
        path: 'lwjgProApplyCertificatTable',
        name: 'lwjgProApplyCertificatTable',
        meta: {
            title: '维修工程交工验收证书',
            auth: true
        },
        component: () =>
            import ('@/views/maintenanceData/roadNetworkRemould/wxzxProApplyCertificatTable')
    },
    {
        path: 'lwjgDelyworkAcceptConTable',
        name: 'lwjgDelyworkAcceptConTable',
        meta: {
            title: '维修工程交工验收报告',
            auth: true
        },
        component: () =>
            import ('@/views/maintenanceData/roadNetworkRemould/wxzxDelyworkAcceptConTable')
    },
    {
        path: 'lwjgQualityScoreTable',
        name: 'lwjgQualityScoreTable',
        meta: {
            title: '交工验收工程质量评分',
            auth: true
        },
        component: () =>
            import ('@/views/maintenanceData/roadNetworkRemould/wxzxQualityScoreTable')
    },
    {
        path: 'lwjgImEvaluateTable',
        name: 'lwjgImEvaluateTable',
        meta: {
            title: '管理综合评价表',
            auth: true
        },
        component: () =>
            import ('@/views/maintenanceData/roadNetworkRemould/wxzxImEvaluateTable')
    },
    {
        path: 'lwjgDesignWorkCeTable',
        name: 'lwjgDesignWorkCeTable',
        meta: {
            title: '设计工作综合评价表',
            auth: true
        },
        component: () =>
            import ('@/views/maintenanceData/roadNetworkRemould/wxzxDesignWorkCeTable')
    },
    {
        path: 'lwjgSuperviseCeTable',
        name: 'lwjgSuperviseCeTable',
        meta: {
            title: '监理工作综合评价表',
            auth: true
        },
        component: () =>
            import ('@/views/maintenanceData/roadNetworkRemould/wxzxSuperviseCeTable')
    },
    {
        path: 'lwjgCmceTable',
        name: 'lwjgCmceTable',
        meta: {
            title: '施工管理综合评价表',
            auth: true
        },
        component: () =>
            import ('@/views/maintenanceData/roadNetworkRemould/wxzxCmceTable')
    },
    {
        path: 'lwjgCompletedQgTable',
        name: 'lwjgCompletedQgTable',
        meta: {
            title: '竣工验收委员会工程质量评分表',
            auth: true
        },
        component: () =>
            import ('@/views/maintenanceData/roadNetworkRemould/wxzxCompletedQgTable')
    },
    {
        path: 'lwjgCaCertificateTable',
        name: 'lwjgCaCertificateTable',
        meta: {
            title: '维修工程竣工验收鉴定书',
            auth: true
        },
        component: () =>
            import ('@/views/maintenanceData/roadNetworkRemould/wxzxCaCertificateTable')
    },
    {
        path: 'lwjgCompletedQeTable',
        name: 'lwjgCompletedQeTable',
        meta: {
            title: '竣工验收工程质量评价表',
            auth: true
        },
        component: () =>
            import ('@/views/maintenanceData/roadNetworkRemould/wxzxCompletedQeTable')
    },
    {
        path: 'lwjgComplatedCeTable',
        name: 'lwjgComplatedCeTable',
        meta: {
            title: '竣工验收项目综合评定表',
            auth: true
        },
        component: () =>
            import ('@/views/maintenanceData/roadNetworkRemould/wxzxComplatedCeTable')
    }
]